import { AnimatePresence, motion } from 'framer-motion';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { TranslationsOverride, useScopedTranslate } from '@locale/translate';

export type CancelSaveButtonsProps = TranslationsOverride<typeof translations> & {
  alwaysShow?: boolean;
  isOpen?: boolean;
  onCancel(): void;
  onSave(): void;
  onSuccess?(): void;
  isDisabled?: boolean;
  isSaveDisabled?: boolean;
};

export const CancelSaveButtons = ({
  alwaysShow,
  isOpen,
  isDisabled,
  isSaveDisabled,
  onCancel,
  onSave,
  onSuccess,
  translationsOverride,
}: CancelSaveButtonsProps) => {
  const { t } = useScopedTranslate(translations, translationsOverride);
  const shouldShow = isOpen || alwaysShow;

  const save = async () => {
    await onSave();
    onSuccess?.();
  };

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ opacity: alwaysShow ? 1 : 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, y: -5 }}
        >
          <Stack orientation="horizontal" space={4} justify="flex-end">
            <Button
              variant="secondary"
              isDisabled={isDisabled}
              onClick={onCancel}
              text={t('core.cancel')}
            />
            <Button
              variant="primary-blue"
              isDisabled={isDisabled || isSaveDisabled}
              onClick={save}
              text={t('save')}
            />
          </Stack>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const translations = {
  en: {
    save: 'Save',
  },
  is: {
    save: 'Staðfesta',
  },
};
